import { render, staticRenderFns } from "./OzBox.vue?vue&type=template&id=9188a69a&"
import script from "./OzBox.vue?vue&type=script&lang=ts&"
export * from "./OzBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports